document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.plp-info-carousel__swiper').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      autoHeight: true,   // 추가
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  });
});